import React from "react";
import style from "../../styles/productsCard.module.scss";
import { Link } from "react-router-dom";
import { imageUrl } from "../../baseApi";
import { useCart } from "react-use-cart";
import { trackAddToCart } from "../../utils/tracking";
import { IoCartOutline } from "react-icons/io5";
import { useCartDrawer } from "../../context/CartDrawerContext";
import { unitPrice } from "../../utils/pricing";

const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const { openDrawer } = useCartDrawer();
  const price = Number(product?.price) || 0;
  const discount = Number(product?.discount) || 0;
  const finalPrice = unitPrice(product);
  const photo = product?.photos?.[0]?.url;
  const soldOut = Boolean(product?.notInStock);
  const href = product?.slug ? `/shop/${product.slug}` : "/shop";
  const imageStyle = photo
    ? { backgroundImage: `url(${imageUrl + photo})` }
    : undefined;

  const addToCart = () => {
    if (soldOut) return;
    addItem(product, 1);
    trackAddToCart(product, 1);
    openDrawer();
  };

  const image = (
    <>
      {discount > 0 ? (
        <p className={style.discount}>{`-${Math.round(discount)}%`}</p>
      ) : product?.topProduct ? (
        <p className={style.discount}>TOP</p>
      ) : null}
      {soldOut ? (
        <div className={style.noStock}>
          <p>E shitur</p>
        </div>
      ) : null}
    </>
  );

  return (
    <article className={`${style.card} ${soldOut ? style.soldOut : ""}`}>
      {soldOut ? (
        <div className={style.image} style={imageStyle}>
          {image}
        </div>
      ) : (
        <Link to={href} className={style.image} style={imageStyle}>
          {image}
        </Link>
      )}
      {soldOut ? (
        <span className={style.name}>{product?.Title || "Produkt"}</span>
      ) : (
        <Link to={href} className={style.name}>
          {product?.Title || "Produkt"}
        </Link>
      )}
      <p className={style.priceRow}>
        {discount > 0 ? (
          <span className={style.oldPrice}>{price.toFixed(2)}€</span>
        ) : null}
        <span>{finalPrice.toFixed(2)}€</span>
      </p>
      {soldOut ? (
        <span className={style.sold}>E shitur</span>
      ) : (
        <button type="button" className={style.add} onClick={addToCart}>
          <IoCartOutline size={18} />
          Shto në shportë
        </button>
      )}
    </article>
  );
};

export default ProductCard;
